webpackJsonp([21],{

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var containers = {};

var container = {
  setStateFun: function setStateFun(fun, state) {
    return Object.assign(state, fun.call(this, state));
  },
  setStateProp: function setStateProp(props, state) {
    return Object.assign(state, props);
  },
  getContainer: function getContainer(name) {
    return containers[name];
  },
  getState: function getState(name) {
    return containers[name] ? containers[name].state : undefined;
  },
  setState: function setState(props, name) {
    var newState = typeof props === 'function' ? container.setStateFun(props, container.getState(name)) : container.setStateProp(props, container.getState(name));

    container.getContainer(name).state = newState;
  },
  injectContainer: function injectContainer(name) {
    var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var obj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    containers[name] = { state: s };
    if (obj) {
      obj.container = containers[name];
    }
  },
  connectState: function connectState(containerName, base) {
    base.prototype.getState = function (name) {
      return name ? container.getState(name) : container.getState(containerName);
    };

    base.prototype.setState = function (props, name) {
      name ? container.setState(props, name) : container.setState(props, containerName);
    };
  }
};

module.exports = container;

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* globals OptimizeSuite */



var trackingHubAdd = function trackingHubAdd(name, data) {
  return OptimizeSuite.TrackingHub.add(name, data);
};

module.exports = trackingHubAdd;

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-env browser, jquery */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var trackingHubAdd = __webpack_require__(246);
var FetchHandler = __webpack_require__(280);
var UgcPhotosModel = __webpack_require__(281);

var HELPFUL = 'like';
var NOT_HELPFUL = 'dislike';
var GALLERY_MODAL_IMAGE_COUNT = 20;
var GALLERY_MODAL_IMAGE_COUNT_INIT = GALLERY_MODAL_IMAGE_COUNT * 2;

var handleUnfilledAbstractMethod = function handleUnfilledAbstractMethod(methodName) {
  if (false) {
    throw new Error(methodName + ' hasnt been implemented');
  }
};

var UgcPhotosAbstract = function () {
  function UgcPhotosAbstract(modalSelector, inlineSelector, gallerySelectors) {
    _classCallCheck(this, UgcPhotosAbstract);

    this.model = new UgcPhotosModel();

    this.$modal = $(modalSelector);
    this.gallerySelectors = gallerySelectors;
    $(inlineSelector).on('click', 'li', this.onImageClick.bind(this));

    this.setupReportModal();

    this.$inlineOpenGalleryLink = $(gallerySelectors.galleryLink);
    var $galleryModal = $(gallerySelectors.galleryModal);

    this.galleryModal = {
      $el: $galleryModal,
      $section: $galleryModal.find('.image-gallery'),
      $imageList: $galleryModal.find('ul'),
      $loader: $galleryModal.find('.loader'),
      $closeIcon: $galleryModal.find('.close-modal')
    };

    this.fetchingGallery = false;
    this.pagination = {};
    this.currentCount = 0;
    this.fetchGalleryImageUrls(0, GALLERY_MODAL_IMAGE_COUNT_INIT, true);

    this.HELPFUL_ACTIVE_CLASSES = '';

    var baseOpts = {
      body: {
        merchantId: this.model.get('merchantUuid')
      },
      credentials: 'include',
      method: 'post'
    };
    this.helpfulFetchHandler = new FetchHandler({
      successHandlers: [this.onHelpfulSuccess.bind(this)],
      errorHandlers: [this.onAjaxError.bind(this, 'helpful', false)],
      requestOpts: baseOpts,
      url: this.model.get('helpfulUrl')
    });

    this.reportFetchHandler = new FetchHandler({
      successHandlers: [this.onReportSuccess.bind(this)],
      errorHandlers: [this.onAjaxError.bind(this, 'report', false)],
      requestOpts: baseOpts,
      url: this.model.get('reportUrl')
    });
  }

  /* eslint-disable class-methods-use-this */


  _createClass(UgcPhotosAbstract, [{
    key: 'setupReportModal',
    value: function setupReportModal() {
      /* defaults are needed for abstract class tests */
      this.reportModal = {
        $textarea: $('#ugc-report-photo-modal textarea'),
        $reasons: $('#ugc-report-photo-modal #ugc-photo-report-dropdown')
      };
      handleUnfilledAbstractMethod('setupReportModal');
    }
  }, {
    key: 'onReportTextareaChange',
    value: function onReportTextareaChange() {
      handleUnfilledAbstractMethod('onReportTextareaChange');
    }
  }, {
    key: 'onImageClick',
    value: function onImageClick() {
      handleUnfilledAbstractMethod('onImageClick');
    }
  }, {
    key: 'getReportModalReason',
    value: function getReportModalReason() {
      handleUnfilledAbstractMethod('getReportModalReason');
    }
  }, {
    key: 'openGalleryViewModal',
    value: function openGalleryViewModal() {
      handleUnfilledAbstractMethod('openGalleryViewModal');
    }
  }, {
    key: 'changeReportReason',
    value: function changeReportReason() {
      handleUnfilledAbstractMethod('changeReportReason');
    }
  }, {
    key: 'openReportModal',
    value: function openReportModal() {
      handleUnfilledAbstractMethod('openReportModal');
    }
  }, {
    key: 'onReportSuccess',
    value: function onReportSuccess() {
      handleUnfilledAbstractMethod('onReportSuccess');
    }
  }, {
    key: 'onAjaxError',
    value: function onAjaxError() {
      handleUnfilledAbstractMethod('onAjaxError');
    }
  }, {
    key: 'openNotificationModal',
    value: function openNotificationModal() {
      handleUnfilledAbstractMethod('openNotificationModal');
    }
    /* eslint-enable */

  }, {
    key: 'debounced',
    value: function debounced(fun) {
      var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
      var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      return this._debounce(fun, wait, immediate).bind(this);
    }
  }, {
    key: '_debounce',
    value: function _debounce(func, wait, immediate) {
      var _this = this;

      var timeout = void 0;
      return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var context = _this;
        var later = function later() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }
  }, {
    key: 'onGalleryScroll',
    value: function onGalleryScroll(scrollPosition) {
      // start fetching just before we reach the last row of images
      var height = this.galleryModal.$imageList.height() - this.galleryModal.$imageList.find('li img').height();
      if (scrollPosition >= height && this.currentCount < this.pagination.count) {
        this.fetchGalleryImageUrls(this.currentCount);
      }
    }
  }, {
    key: 'fetchGalleryImageUrls',
    value: function fetchGalleryImageUrls() {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var _this2 = this;

      var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : GALLERY_MODAL_IMAGE_COUNT;
      var fetchReasons = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (!this.fetchingGallery && (this.pagination.count === undefined || this.pagination.count > offset)) {
        this.fetchingGallery = true;
        var url = this.model.get('fetchUrl') + '&limit=' + limit + '&offset=' + offset + '&fetchReasons=' + fetchReasons;
        this.galleryModal.$loader.addClass('show-loader');

        $.ajax({
          method: 'GET',
          dataType: 'json',
          url: url,
          success: function success(data) {
            return _this2.onFetchGalleryImageUrlsSuccess(data, fetchReasons, limit);
          },
          complete: function complete() {
            _this2.fetchingGallery = false;
            if (_this2.currentCount >= _this2.pagination.count) {
              _this2.galleryModal.$loader.addClass('hide-loader');
            }
            _this2.galleryModal.$loader.removeClass('show-loader');
          }
        });
      }
    }
  }, {
    key: 'onFetchGalleryImageUrlsSuccess',
    value: function onFetchGalleryImageUrlsSuccess(data, fetchReasons, limit) {
      if (!data || !Object.keys(data).length) {
        return;
      }

      this.currentCount += limit;
      this.addToImageData(data, limit);
      if (this.pagination.offset === 0) {
        this.initFillGalleryViewModal();
        this.$inlineOpenGalleryLink.on('click', this.openGalleryViewModal.bind(this));
      } else {
        this.appendGalleryViewModal();
      }

      if (fetchReasons) {
        this.setReportingReasons(data.reportReasonsHtml);
      }
    }
  }, {
    key: 'addToImageData',
    value: function addToImageData(_ref) {
      var _ref$pagination = _ref.pagination,
          pagination = _ref$pagination === undefined ? null : _ref$pagination,
          _ref$imagesByUuid = _ref.imagesByUuid,
          imagesByUuid = _ref$imagesByUuid === undefined ? {} : _ref$imagesByUuid,
          _ref$ids = _ref.ids,
          ids = _ref$ids === undefined ? [] : _ref$ids;

      this.pagination = pagination;
      this.model.addImages(imagesByUuid, ids);
    }
  }, {
    key: 'setReportingReasons',
    value: function setReportingReasons(reportReasonsHtml) {
      this.reportModal.$reasons.append(reportReasonsHtml);
      this.$modal.find('.report-link').show();
      var openReportModalOnLoad = this.model.get('openReportModalOnLoad');
      if (openReportModalOnLoad) {
        if (openReportModalOnLoad.reportUuid === this.model.get('otherReasonUuid') && window.sessionStorage) {
          this.reportModal.$textarea.val(window.sessionStorage.getItem('ugcPhotos.reportOtherReasonText'));
          window.sessionStorage.removeItem('ugcPhotos.reportOtherReasonText');
          this.onReportTextareaChange();
        }
        this.changeReportReason(openReportModalOnLoad.reportUuid);
      }
    }
  }, {
    key: 'redirectToLogin',
    value: function redirectToLogin() {
      var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var event = arguments[1];

      var returnTo = window.location.origin + window.location.pathname;
      var params = void 0;

      if (from === 'helpful') {
        params = 'helpful=true&imageUuid=' + this.$modal.attr('data-active-id');
      } else {
        params = 'reportPhoto=true&imageUuid=' + this.$modal.attr('data-active-id') + '&reportUuid=' + this.getReportModalReason(event);
      }

      if (window.location.search) {
        returnTo += window.location.search + '&';
      } else {
        returnTo += '?';
      }

      returnTo += params;
      window.location.assign(this.model.get('loginUrlBase') + '?return_to=' + encodeURIComponent(returnTo));
    }
  }, {
    key: 'saveTextInLocalStorage',
    value: function saveTextInLocalStorage(reasonText) {
      if (!window.sessionStorage) {
        return;
      }
      window.sessionStorage.setItem('ugcPhotos.reportOtherReasonText', reasonText);
    }
  }, {
    key: 'onReportSubmit',
    value: function onReportSubmit(event) {
      event.preventDefault();
      var reasonId = this.getReportModalReason(event);

      var infringingContent = this.model.get('infringingContent');
      if (reasonId === infringingContent.uuid) {
        window.open(window.location.origin + infringingContent.url);
        return;
      }

      var isOtherReason = reasonId === this.model.get('otherReasonUuid');
      var reasonText = isOtherReason ? this.reportModal.$textarea.val() : undefined;

      if (!this.model.isLoggedIn()) {
        if (isOtherReason) {
          this.saveTextInLocalStorage(reasonText);
        }
        this.redirectToLogin('report', event);
        return;
      }

      return this.reportFetchHandler.send({
        imageId: this.$modal.attr('data-active-id'),
        reasonId: reasonId,
        reasonText: reasonText
      });
    }
  }, {
    key: 'meetsMinimumTextareaLength',
    value: function meetsMinimumTextareaLength() {
      return this.reportModal.$textarea.val().length > this.model.get('minimumReportTextLength');
    }
  }, {
    key: 'initFillGalleryViewModal',
    value: function initFillGalleryViewModal() {
      var galleryHtml = this.galleryTemplate(this.model.ids());
      this.galleryModal.$imageList.html(galleryHtml);
      this.galleryModal.$imageList.on('click', 'li', this.onImageClick.bind(this));
    }
  }, {
    key: 'appendGalleryViewModal',
    value: function appendGalleryViewModal() {
      var currentIds = this.model.ids();
      var ids = currentIds.slice(this.currentCount - GALLERY_MODAL_IMAGE_COUNT);
      this.galleryModal.$imageList.append(this.galleryTemplate(ids));
    }
  }, {
    key: 'galleryTemplate',
    value: function galleryTemplate(ids) {
      var _this3 = this;

      var galleryImagesHtml = '';
      ids.forEach(function (id) {
        if (id) {
          var image = _this3.model.getImageData(id);
          galleryImagesHtml += '<li data-id=\'' + id + '\'><img alt=\'' + image.alt + '\' src=\'' + image.galleryUrl + '\'/></li>';
        }
      });
      return galleryImagesHtml;
    }

    // helpfulButton

  }, {
    key: 'getHelpfulClass',
    value: function getHelpfulClass() {
      return this.HELPFUL_ACTIVE_CLASSES;
    }
  }, {
    key: 'getHelpfulState',
    value: function getHelpfulState(id) {
      return this.model.getImageData(id).helpfulState;
    }
  }, {
    key: 'getHelpfulAction',
    value: function getHelpfulAction(id) {
      return this.model.getImageData(id).helpfulState === HELPFUL ? NOT_HELPFUL : HELPFUL;
    }
  }, {
    key: 'onHelpfulButtonClick',
    value: function onHelpfulButtonClick(event) {
      if (!this.model.isLoggedIn()) {
        this.redirectToLogin('helpful', event);
        return;
      }

      var imageId = this.$modal.attr('data-active-id');
      var imageData = this.model.getImageData(imageId);
      var action = this.getHelpfulAction(imageId);

      trackingHubAdd('UgcPhotosHelpfulClick', {
        ugc_image_id: imageId,
        ugc_image_url: imageData.url
      });

      return this.helpfulFetchHandler.send({
        action: action,
        imageId: imageId
      });
    }
  }, {
    key: 'onHelpfulSuccess',
    value: function onHelpfulSuccess(_ref2) {
      var id = _ref2.id;

      var action = this.getHelpfulAction(id);
      this.setHelpfulState(id, action);
      this.setHelpfulCount(id, action);
    }
  }, {
    key: 'setHelpfulState',
    value: function setHelpfulState(id, action) {
      this.model.updateImageData(id, { helpfulState: action });
    }
  }, {
    key: 'setHelpfulCount',
    value: function setHelpfulCount(id, action) {
      var image = this.model.getImageData(id);

      var count = void 0;
      switch (action) {
        case HELPFUL:
          count = image.helpfulCount + 1;
          break;
        case NOT_HELPFUL:
          count = image.helpfulCount - 1;
          break;
        default:
          count = image.helpfulCount;
      }

      this.model.updateImageData(id, { helpfulCount: count });
      return count;
    }
  }, {
    key: 'setHelpfulButtonViewState',
    value: function setHelpfulButtonViewState(arg) {
      var id = (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' ? arg.id : arg;
      var action = this.getHelpfulState(id);

      switch (action) {
        case HELPFUL:
          return this._setHelpfulButtonView(id);
        case NOT_HELPFUL:
          return this._setNotHelpfulButtonView(id);
        default:
          return this._setNotHelpfulButtonView(id);
      }
    }
  }]);

  return UgcPhotosAbstract;
}();

UgcPhotosAbstract.HELPFUL = HELPFUL;
UgcPhotosAbstract.NOT_HELPFUL = NOT_HELPFUL;

module.exports = UgcPhotosAbstract;

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var callHandlers = function callHandlers(fns, args) {
  fns.forEach(function (handler) {
    return handler(args);
  });
};

var FetchHandler = function () {
  function FetchHandler(_ref) {
    var completeHandlers = _ref.completeHandlers,
        successHandlers = _ref.successHandlers,
        errorHandlers = _ref.errorHandlers,
        _ref$requestOpts = _ref.requestOpts,
        requestOpts = _ref$requestOpts === undefined ? {} : _ref$requestOpts,
        url = _ref.url;

    _classCallCheck(this, FetchHandler);

    this.url = url;

    this.requestOpts = requestOpts;
    if (!(this.requestOpts.headers instanceof Headers)) {
      this.requestOpts.headers = new Headers();
    }
    this.requestOpts.headers.append('X-Requested-With', 'XMLHttpRequest');
    this.requestOpts.headers.append('Accept', 'application/json');
    this.requestOpts.headers.append('Accept', 'text/html');

    this.completeHandlers = [];
    this.successHandlers = [];
    this.errorHandlers = [];
    this.setHandlers({ completeHandlers: completeHandlers, successHandlers: successHandlers, errorHandlers: errorHandlers });

    this.fetchInFlight = false;
  }

  _createClass(FetchHandler, [{
    key: 'setHandlers',
    value: function setHandlers(_ref2) {
      var _ref2$completeHandler = _ref2.completeHandlers,
          completeHandlers = _ref2$completeHandler === undefined ? [] : _ref2$completeHandler,
          _ref2$successHandlers = _ref2.successHandlers,
          successHandlers = _ref2$successHandlers === undefined ? [] : _ref2$successHandlers,
          _ref2$errorHandlers = _ref2.errorHandlers,
          errorHandlers = _ref2$errorHandlers === undefined ? [] : _ref2$errorHandlers;

      this.completeHandlers = this.completeHandlers.concat(completeHandlers);
      this.successHandlers = this.successHandlers.concat(successHandlers);
      this.errorHandlers = this.errorHandlers.concat(errorHandlers);
    }
  }, {
    key: 'send',
    value: function send(data) {
      var _this = this;

      if (this.fetchInFlight) {
        return;
      }

      var hasBody = data !== undefined || !!this.requestOpts.body !== undefined;

      var opts = Object.assign({}, this.requestOpts, {
        body: hasBody ? JSON.stringify(Object.assign({}, this.requestOpts.body, data)) : undefined
      });

      if (hasBody) {
        opts.headers.set('Content-Type', 'application/json');
      }

      var request = new Request(this.url, opts);

      this.fetchInFlight = true;
      return fetch(request).then(function (response) {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error('FetchHandler: request received error with status ' + response.status);
        }
      }).then(this.handleSuccess.bind(this)).catch(function (e) {
        if (_this.errorHandlers.length) {
          return _this.handleError(e);
        } else {
          throw e;
        }
      }.bind(this)).then(this.handleComplete.bind(this));
    }
  }, {
    key: 'handleComplete',
    value: function handleComplete() {
      callHandlers(this.completeHandlers);
      this.fetchInFlight = false;
    }
  }, {
    key: 'handleSuccess',
    value: function handleSuccess(response) {
      callHandlers(this.successHandlers, response);
    }
  }, {
    key: 'handleError',
    value: function handleError(error) {
      callHandlers(this.errorHandlers, error);
    }
  }]);

  return FetchHandler;
}();

module.exports = FetchHandler;

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint no-underscore-dangle: ["error", { "allowAfterThis": true }] */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(222),
    connectState = _require.connectState;

var UgcPhotosModel = function () {
  function UgcPhotosModel() {
    _classCallCheck(this, UgcPhotosModel);

    this.state = this.getState();
  }

  /*
   * currently only gets shallow
  */


  _createClass(UgcPhotosModel, [{
    key: 'get',
    value: function get(prop) {
      if (prop === 'state') {
        return this._clone(this.state);
      }

      var stateProp = this.state[prop];

      switch (stateProp) {
        case Array.isArray(stateProp):
        case (typeof stateProp === 'undefined' ? 'undefined' : _typeof(stateProp)) === 'object':
          return this._clone(stateProp);
        default:
          return stateProp;
      }
    }

    /*
     * This base clone should works well for our state object
     * since it should not contain functions
     * or model instances, only primitives, arrays
     * and objects
     *
    */

  }, {
    key: '_clone',
    value: function _clone(prop) {
      return JSON.parse(JSON.stringify(prop));
    }
  }, {
    key: 'addImages',
    value: function addImages(newImagesByUuid, ids) {
      this.addImagesByIds(ids);
      this.addImagesByUuid(newImagesByUuid);
    }
  }, {
    key: 'getImageData',
    value: function getImageData(uuid) {
      if (this.state.imagesByUuid[uuid]) {
        return this.get('imagesByUuid')[uuid];
      }
      return undefined;
    }
  }, {
    key: 'getImageUuid',
    value: function getImageUuid(index) {
      return this.state.ids[index];
    }
  }, {
    key: 'getImageIndex',
    value: function getImageIndex(uuid) {
      return this.state.ids.indexOf(uuid);
    }
  }, {
    key: 'addImagesByUuid',
    value: function addImagesByUuid(newImagesByUuid) {
      this.setState(function (prevState) {
        return {
          imagesByUuid: Object.assign({}, newImagesByUuid, prevState.imagesByUuid)
        };
      });
    }
  }, {
    key: 'updateImageData',
    value: function updateImageData(uuid, props) {
      var imageData = Object.assign({}, this.getImageData(uuid), props);

      this.setState(function (prevState) {
        return {
          imagesByUuid: Object.assign({}, prevState.imagesByUuid, _defineProperty({}, '' + uuid, Object.assign({}, prevState.imagesByUuid['' + uuid], imageData)))
        };
      });
    }
  }, {
    key: 'addImagesByIds',
    value: function addImagesByIds(ids) {
      var _this = this;

      var newIds = ids.reduce(function (arr, id) {
        return _this.getImageData(id) ? arr : arr.concat(id);
      }, this.state.ids);
      this.setState({ ids: newIds });
    }
  }, {
    key: 'ids',
    value: function ids() {
      return this.get('ids');
    }
  }, {
    key: 'imagesByUuid',
    value: function imagesByUuid() {
      return this.get('imagesByUuid');
    }
  }, {
    key: 'isLoggedIn',
    value: function isLoggedIn() {
      return this.get('isLoggedIn');
    }
  }]);

  return UgcPhotosModel;
}();

connectState('ugcPhotos', UgcPhotosModel);

module.exports = UgcPhotosModel;

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cleanUpUrlAfterRedirect = function cleanUpUrlAfterRedirect(regex) {
  var newUrl = window.location.href.split(regex)[0];
  if (window.history.pushState) {
    window.history.pushState(null, null, newUrl);
  } else {
    document.location.href = newUrl;
  }
};

module.exports = cleanUpUrlAfterRedirect;

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-env browser, jquery */



// disable right click on images

module.exports = {
  disabled: function disabled(el) {
    var _this = this;

    $(el).on('contextmenu', 'img', function (e) {
      return _this._prevent(e);
    });
  },
  _prevent: function _prevent() /* e */{
    // stopPropagation and preventDefault
    return false;
  }
};

/***/ }),

/***/ 284:
/***/ (function(module, exports) {

if (window.GliveBookingWrapper == null) {
  window.GliveBookingWrapper = {};
}

GliveBookingWrapper.init = function(arg, done) {
  var gliveBooker;
  gliveBooker = arg.gliveBooker;
  if (!(gliveBooker != null ? gliveBooker.isGliveDeal : void 0)) {
    return done();
  }
  return $(function() {
    return BookingV2.gliveDealBookerInit(false, gliveBooker, done);
  });
};


/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var CountdownTimer, addLeadingZero, countdownTimeKey, countdownTimestamp, millisRemaining, shouldShowTimerForGoods, timeRemaining;

timeRemaining = function(timeRemainingMilliseconds) {
  var days, hours, millisecondsLeft, minutes, seconds;
  if (timeRemainingMilliseconds == null) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  }
  days = Math.floor(timeRemainingMilliseconds / (1000 * 3600 * 24));
  millisecondsLeft = Math.floor(timeRemainingMilliseconds - days * (1000 * 3600 * 24));
  hours = Math.floor(millisecondsLeft / (1000 * 3600));
  millisecondsLeft = Math.floor(millisecondsLeft - hours * (1000 * 3600));
  minutes = Math.floor(millisecondsLeft / (1000 * 60));
  millisecondsLeft = Math.floor(millisecondsLeft - minutes * 1000 * 60);
  seconds = Math.floor(millisecondsLeft / 1000);
  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
};

millisRemaining = function(endTime) {
  var millsRemaining, rightNow;
  if (endTime == null) {
    return 0;
  }
  rightNow = new Date().getTime();
  millsRemaining = endTime - rightNow;
  if (millsRemaining < 0) {
    return 0;
  } else {
    return millsRemaining;
  }
};

addLeadingZero = function(number) {
  if (number < 0) {
    return;
  }
  if (number < 10) {
    return "0" + number;
  } else {
    return "" + number;
  }
};

countdownTimeKey = function(timeLeft, ignoreCap) {
  if (ignoreCap == null) {
    ignoreCap = false;
  }
  switch (false) {
    case !(timeLeft.days >= 15 && !ignoreCap):
      return "";
    case !(timeLeft.days > 1):
      return ".countdown_time_many_days";
    case timeLeft.days !== 1:
      return ".countdown_time_1_day";
    default:
      return ".countdown_time_today";
  }
};

countdownTimestamp = function(timeLeft) {
  var hh, mm, ss;
  hh = addLeadingZero(timeLeft.hours);
  mm = addLeadingZero(timeLeft.minutes);
  ss = addLeadingZero(timeLeft.seconds);
  return hh + ":" + mm + ":" + ss;
};

shouldShowTimerForGoods = function(dealTimer, timeLeft) {
  switch (dealTimer) {
    case 'lessThanEqualTo7Days':
      return timeLeft.days < 7 || (timeLeft.days === 7 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0);
    case 'lessThanEqualTo3Days':
      return timeLeft.days < 3 || (timeLeft.days === 3 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0);
    case 'lessThanEqualTo1Day':
      return timeLeft.days < 1 || (timeLeft.days === 1 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0);
    case 'lessThanEqualTo12Hrs':
      return (timeLeft.days === 0 && timeLeft.hours < 12) || (timeLeft.days === 0 && timeLeft.hours === 12 && timeLeft.minutes === 0 && timeLeft.seconds === 0);
    default:
      return true;
  }
};

if (typeof window !== "undefined" && window !== null) {
  CountdownTimer = window.CountdownTimer != null ? window.CountdownTimer : window.CountdownTimer = {};
  if (CountdownTimer.Helpers == null) {
    CountdownTimer.Helpers = {};
  }
  CountdownTimer.Helpers.timeRemaining = timeRemaining;
  CountdownTimer.Helpers.millisRemaining = millisRemaining;
  CountdownTimer.Helpers.countdownTimeKey = countdownTimeKey;
  CountdownTimer.Helpers.countdownTimestamp = countdownTimestamp;
  CountdownTimer.Helpers.shouldShowTimerForGoods = shouldShowTimerForGoods;
}

if (typeof module !== "undefined" && module !== null) {
  module.exports = {
    timeRemaining: timeRemaining,
    millisRemaining: millisRemaining,
    countdownTimeKey: countdownTimeKey,
    countdownTimestamp: countdownTimestamp,
    shouldShowTimerForGoods: shouldShowTimerForGoods
  };
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(422);
__webpack_require__(49);
__webpack_require__(423);
__webpack_require__(425);
__webpack_require__(284);
__webpack_require__(247);
__webpack_require__(427);
__webpack_require__(434);

// script to separate Js in chunks and load async modules
__webpack_require__(435);

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-env browser */



var UgcPhotosWidget = __webpack_require__(424);
var contextmenu = __webpack_require__(283);

var _require = __webpack_require__(222),
    injectContainer = _require.injectContainer;

var UgcPhotos = {
  init: function init(_ref, done) {
    var ugcPhotos = _ref.ugcPhotos;

    injectContainer('ugcPhotos', ugcPhotos, window.UgcPhotos);
    var photoWidget = new UgcPhotosWidget(); // eslint-disable-line no-unused-vars
    contextmenu.disabled('#ugc-photos, #ugc-photos-modal');
    return done();
  }
};

window.UgcPhotos = UgcPhotos;
module.exports = UgcPhotos;

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-env browser, jquery */
/* globals GIG */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UgcPhotosAbstract = __webpack_require__(279);
var _ = __webpack_require__(1);
var trackingHubAdd = __webpack_require__(246);
var cleanUpUrlAfterRedirect = __webpack_require__(282);

var GALLERY_MAX_HEIGHT = 1000;

var MODAL_SINGLE_VIEW = '.single-view-modal';
var MODAL_GALLERY_VIEW = '.gallery-view-modal';

var UgcPhotosDesktop = function (_UgcPhotosAbstract) {
  _inherits(UgcPhotosDesktop, _UgcPhotosAbstract);

  function UgcPhotosDesktop() {
    var modalSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#ugc-photos-modal';
    var inlineSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.ugc-photos';
    var galleryOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, UgcPhotosDesktop);

    var gallerySelectors = _.extend({
      galleryModal: modalSelector + ' .gallery-view-modal',
      galleryLink: modalSelector + ' .open-ugc-gallery-modal'
    }, galleryOptions);

    var _this = _possibleConstructorReturn(this, (UgcPhotosDesktop.__proto__ || Object.getPrototypeOf(UgcPhotosDesktop)).call(this, modalSelector, inlineSelector, gallerySelectors));

    _this.$helpfulButton = _this.$modal.find('.helpful-btn');
    _this.$helpfulButton.on('click', _get(UgcPhotosDesktop.prototype.__proto__ || Object.getPrototypeOf(UgcPhotosDesktop.prototype), 'onHelpfulButtonClick', _this).bind(_this));
    _this.HELPFUL_ACTIVE_CLASSES = 'c-bg-prim c-txt-white';

    if (_this.model.get('hasMultipleImages')) {
      var $elem = _this.$modal.find('.controls');

      _this.$backwardControl = $elem.find('.back');
      _this.$backwardControl.on('click', _this.onControlsClick.bind(_this, 'back'));

      _this.$forwardControl = $elem.find('.forward');
      _this.$forwardControl.on('click', _this.onControlsClick.bind(_this, 'forward'));
    }

    _this.$modal.find('.report-link').on('click', function () {
      return _this.openReportModal();
    });
    _this.reportModal.$el.on('click', _this.closeReportModal.bind(_this));
    _this.reportModal.$reasons.on('change', _this.onReportReasonChange.bind(_this));
    _this.reportModal.$el.find('form').on('submit', _this.onReportSubmit.bind(_this));
    _this.reportModal.$el.find('.modal-body').on('click', function (event) {
      return event.stopPropagation();
    });

    _this.setupNotificationModal();

    _this.galleryModal.$section.on('scroll', _this.debounced(_this.onGalleryScroll));

    // reset the height each time the img changes
    var $singleViewImg = _this.$modal.find('.single-image img');
    $singleViewImg[0].onload = function () {
      var naturalHeight = this.naturalHeight,
          naturalWidth = this.naturalWidth;

      var naturalRatio = naturalHeight / naturalWidth;
      var newModalWidth = Math.min($(modalSelector + ' .single-view-modal').width(), naturalWidth);
      $singleViewImg.css('height', naturalRatio * newModalWidth);
    };

    _this.helpfulFetchHandler.setHandlers({
      successHandlers: [_this.setHelpfulButton.bind(_this)]
    });

    cleanUpUrlAfterRedirect(/([?&](helpful|reportPhoto)=true.*)/);
    var openReportModalOnLoad = _this.model.get('openReportModalOnLoad');
    if (openReportModalOnLoad) {
      _this.fillSingleViewModal(openReportModalOnLoad.imageUuid);
      _this.openSingleViewModal();
      _this.openReportModal();
    }

    var openHelpfulModalOnLoad = _this.model.get('openHelpfulModalOnLoad');
    if (openHelpfulModalOnLoad) {
      _this.fillSingleViewModal(openHelpfulModalOnLoad.imageUuid);
      _this.openSingleViewModal();
    }
    return _this;
  }

  _createClass(UgcPhotosDesktop, [{
    key: 'setupReportModal',
    value: function setupReportModal() {
      var $reportModal = $('#ugc-report-photo-modal');
      this.reportModal = {
        $el: $reportModal,
        $reasons: $reportModal.find('#ugc-photo-report-dropdown'),
        $textarea: $reportModal.find('textarea'),
        $form: $reportModal.find('form'),
        $submitButton: $reportModal.find('button'),
        $closeIcon: $reportModal.find('.close-modal')
      };

      this.reportModal.$textarea.on('input', this.onReportTextareaChange.bind(this));
      this.reportModal.$closeIcon.on('click', this.closeReportModal.bind(this));
    }
  }, {
    key: 'setupNotificationModal',
    value: function setupNotificationModal() {
      this.$notificationModal = $('#ugc-notification-modal');

      this.$notificationModal.find('.close-modal').on('click', this.closeNotificationModal.bind(this));

      this.$notificationModal.on('click', this.closeNotificationModal.bind(this));
      this.$notificationModal.find('.modal-body').on('click', function (event) {
        return event.stopPropagation();
      });
    }
  }, {
    key: 'fillHeader',
    value: function fillHeader(_ref) {
      var _ref$postDate = _ref.postDate,
          postDate = _ref$postDate === undefined ? '' : _ref$postDate,
          _ref$username = _ref.username,
          username = _ref$username === undefined ? '' : _ref$username,
          _ref$userInitials = _ref.userInitials,
          userInitials = _ref$userInitials === undefined ? '' : _ref$userInitials;

      this.$modal.find('.post-date').text(postDate);
      this.$modal.find('.name').text(username);
      this.$modal.find('.user-initials').text(userInitials);
    }
  }, {
    key: 'fillGallery',
    value: function fillGallery(_ref2) {
      var url = _ref2.url,
          alt = _ref2.alt;

      var $modalImg = this.$modal.find('.single-image img');
      $modalImg.attr('src', '');
      $modalImg.attr('src', url);
      $modalImg.attr('alt', alt);
    }
  }, {
    key: 'fillSingleViewModal',
    value: function fillSingleViewModal(id) {
      var imageData = this.model.getImageData(id);
      if (!imageData) return;
      this.$modal.attr('data-active-id', id);
      this.fillGallery(imageData);
      this.fillHeader(imageData);
      _get(UgcPhotosDesktop.prototype.__proto__ || Object.getPrototypeOf(UgcPhotosDesktop.prototype), 'setHelpfulState', this).call(this, id, imageData.helpfulState);
      this.setHelpfulButton(id);
    }
  }, {
    key: 'onControlsClick',
    value: function onControlsClick(direction) {
      var newIndex = void 0;
      var currentIndex = this.model.getImageData(this.$modal.attr('data-active-id')).index;

      var ids = this.model.ids();
      if (direction === 'back') {
        newIndex = currentIndex === 0 ? ids.length - 1 : currentIndex - 1;
      } else if (direction === 'forward') {
        newIndex = currentIndex === ids.length - 1 ? 0 : currentIndex + 1;
      }

      if (newIndex === undefined) return;

      this.fillSingleViewModal(ids[newIndex]);
      this.clearReportModal();

      if (direction === 'forward' && ids.length - newIndex < 2) {
        this.fetchGalleryImageUrls(this.currentCount);
      }
    }
  }, {
    key: 'onImageClick',
    value: function onImageClick(event) {
      var $el = $(event.currentTarget);
      if ($el.find('.view-all-images-overlay').length > 0) {
        this.openGalleryViewModal();
      } else {
        this.fillSingleViewModal($el.attr('data-id'));
        this.openSingleViewModal();
      }
    }
  }, {
    key: 'onGalleryScroll',
    value: function onGalleryScroll() {
      _get(UgcPhotosDesktop.prototype.__proto__ || Object.getPrototypeOf(UgcPhotosDesktop.prototype), 'onGalleryScroll', this).call(this, this.scrollPosition());
    }
  }, {
    key: 'scrollPosition',
    value: function scrollPosition() {
      return this.galleryModal.$section.scrollTop() + this.galleryModal.$section.height();
    }
  }, {
    key: 'onModalResizer',
    value: function onModalResizer(fun) {
      $(window).on('resize.ugcModalResizer', this.debounced(fun));
    }
  }, {
    key: 'onModalResizerClose',
    value: function onModalResizerClose() {
      $(window).off('resize.ugcModalResizer');
    }
  }, {
    key: 'setSingleViewModalMaxHeight',
    value: function setSingleViewModalMaxHeight() {
      var modalHeight = this.$modal.height();
      if (!this.singleViewModalHeightOffset) {
        this.singleViewModalHeightOffset = this.$modal.find('.single-view-header').outerHeight();
      }
      var heightCalc = modalHeight - this.singleViewModalHeightOffset;
      this.$modal.find('.single-image img').css('max-height', heightCalc + 'px');

      return heightCalc;
    }
  }, {
    key: '_showImageModal',
    value: function _showImageModal(modalSelector, resizerFun) {
      if (!window.GIG || !window.GIG.Modal) return;

      this.$modal.find(MODAL_SINGLE_VIEW + ', ' + MODAL_GALLERY_VIEW).css('display', 'none');
      this.$modal.find(modalSelector).css('display', 'block');

      GIG.Modal.open({ el: this.$modal });
      GIG.Modal.onClose(this.onModalResizerClose, this.$modal.attr('id'), true);

      resizerFun.call(this);
      this.onModalResizer(resizerFun);
    }
  }, {
    key: 'openSingleViewModal',
    value: function openSingleViewModal() {
      this._showImageModal(MODAL_SINGLE_VIEW, this.setSingleViewModalMaxHeight);
      this.clearReportModal();
      this._setupLeftRightArrowHandlers();
    }
  }, {
    key: '_setupLeftRightArrowHandlers',
    value: function _setupLeftRightArrowHandlers() {
      var _this2 = this;

      $(document.body).on('keyup.singleViewModal', function (e) {
        if (_this2.reportModal.$el.hasClass('show-modal') || _this2.$notificationModal.hasClass('show-modal')) {
          return;
        } else if (e.key === 'ArrowLeft') {
          _this2.onControlsClick('back');
        } else if (e.key === 'ArrowRight') {
          _this2.onControlsClick('forward');
        }
      }.bind(this));
      GIG.Modal.onClose(function () {
        return $(document.body).off('keyup.singleViewModal');
      }, this.$modal.attr('id'), true);
    }
  }, {
    key: 'getGalleryHeightOffset',
    value: function getGalleryHeightOffset() {
      return this.$modal.find('.gallery-view-modal header').outerHeight() + this.$modal.find('.gallery-view-modal footer').outerHeight();
    }
  }, {
    key: 'setGalleryMaxHeight',
    value: function setGalleryMaxHeight() {
      var modalHeight = this.$modal.height();

      this.galleryViewModalHeightOffset = this.getGalleryHeightOffset();

      var maxHeight = modalHeight - this.galleryViewModalHeightOffset;

      this.galleryModal.$section.css('max-height', Math.min(GALLERY_MAX_HEIGHT, maxHeight) + 'px');

      return maxHeight;
    }
  }, {
    key: 'openGalleryViewModal',
    value: function openGalleryViewModal() {
      this._showImageModal(MODAL_GALLERY_VIEW, this.setGalleryMaxHeight);
    }
  }, {
    key: 'closeReportModal',
    value: function closeReportModal(event) {
      if (event) {
        event.stopImmediatePropagation();
      }
      this.reportModal.$el.removeClass('show-modal');

      this._removeEscKeyHandler();
    }
  }, {
    key: 'changeReportReason',
    value: function changeReportReason(reportUuid) {
      if (reportUuid) {
        this.reportModal.$reasons.val(reportUuid);
        this.onReportReasonChange();
      }
    }
  }, {
    key: '_addEscKeyHandler',
    value: function _addEscKeyHandler(fn) {
      this.$modal.data('closeonesckey', false);
      $(document.body).on('keyup.secondaryModal', function (e) {
        if (e.key === 'Escape') {
          fn(e);
        }
      });
    }
  }, {
    key: '_removeEscKeyHandler',
    value: function _removeEscKeyHandler() {
      this.$modal.data('closeonesckey', true);
      $(document.body).off('keyup.secondaryModal');
    }
  }, {
    key: 'openReportModal',
    value: function openReportModal() {
      var imageId = this.$modal.attr('data-active-id');
      var imageData = this.model.getImageData(imageId);
      trackingHubAdd('UgcPhotosReportClick', {
        ugc_image_id: imageId,
        ugc_image_url: imageData.url
      });

      this.reportModal.$el.addClass('show-modal');

      this._addEscKeyHandler(this.closeReportModal.bind(this));
    }
  }, {
    key: 'onReportReasonChange',
    value: function onReportReasonChange() {
      var newReason = this.reportModal.$reasons.val();
      var shouldDisableButton = !newReason.length;

      if (newReason === this.model.get('otherReasonUuid')) {
        this.reportModal.$textarea.show();

        shouldDisableButton = !this.meetsMinimumTextareaLength();
      } else {
        this.reportModal.$textarea.hide();
      }

      this.reportModal.$submitButton.prop('disabled', shouldDisableButton);
    }
  }, {
    key: 'clearReportModal',
    value: function clearReportModal() {
      this.reportModal.$reasons.val('');
      this.reportModal.$textarea.val('').hide();
      this.reportModal.$submitButton.prop('disabled', true);
    }
  }, {
    key: 'onReportTextareaChange',
    value: function onReportTextareaChange() {
      this.reportModal.$submitButton.prop('disabled', !this.meetsMinimumTextareaLength());
    }
  }, {
    key: 'getReportModalReason',
    value: function getReportModalReason() {
      return this.reportModal.$reasons.val();
    }
  }, {
    key: 'onReportSuccess',
    value: function onReportSuccess() {
      this.closeReportModal();
      this.openNotificationModal('report', true);
    }
  }, {
    key: 'onAjaxError',
    value: function onAjaxError(type, isSuccess) {
      if (type === 'report') {
        this.closeReportModal();
      }
      this.openNotificationModal(type, isSuccess);
    }
  }, {
    key: 'openNotificationModal',
    value: function openNotificationModal(type) {
      var isSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this.$notificationModal.find('.ugc-notification-header, .ugc-notification-text').hide();

      this.$notificationModal.find('.ugc-notification-header.' + type).show();
      var textClass = isSuccess ? 'success' : 'error';
      this.$notificationModal.find('.ugc-notification-text.' + textClass).show();

      this.$notificationModal.addClass('show-modal');

      this._addEscKeyHandler(this.closeNotificationModal.bind(this));
    }
  }, {
    key: 'closeNotificationModal',
    value: function closeNotificationModal(event) {
      event.stopImmediatePropagation();
      this.$notificationModal.removeClass('show-modal');

      this._removeEscKeyHandler();
    }
  }, {
    key: 'setHelpfulButton',
    value: function setHelpfulButton(arg) {
      this.setHelpfulCountText(arg);
      this.setHelpfulButtonViewState(arg);
    }
  }, {
    key: 'setHelpfulCountText',
    value: function setHelpfulCountText(arg) {
      var id = (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' ? arg.id : arg;
      var count = _get(UgcPhotosDesktop.prototype.__proto__ || Object.getPrototypeOf(UgcPhotosDesktop.prototype), 'setHelpfulCount', this).call(this, id);
      this.$helpfulButton.find('.helpful-count').text('(' + count + ')');
    }
  }, {
    key: 'setHelpfulButtonViewState',
    value: function setHelpfulButtonViewState(arg) {
      _get(UgcPhotosDesktop.prototype.__proto__ || Object.getPrototypeOf(UgcPhotosDesktop.prototype), 'setHelpfulButtonViewState', this).call(this, arg);
    }
  }, {
    key: '_setHelpfulButtonView',
    value: function _setHelpfulButtonView() {
      this.$helpfulButton.addClass(_get(UgcPhotosDesktop.prototype.__proto__ || Object.getPrototypeOf(UgcPhotosDesktop.prototype), 'getHelpfulClass', this).call(this) + ' ' + UgcPhotosAbstract.HELPFUL);
    }
  }, {
    key: '_setNotHelpfulButtonView',
    value: function _setNotHelpfulButtonView() {
      this.$helpfulButton.removeClass(_get(UgcPhotosDesktop.prototype.__proto__ || Object.getPrototypeOf(UgcPhotosDesktop.prototype), 'getHelpfulClass', this).call(this) + ' ' + UgcPhotosAbstract.HELPFUL);
    }
  }]);

  return UgcPhotosDesktop;
}(UgcPhotosAbstract);

module.exports = UgcPhotosDesktop;

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

var TUTORIAL_SHOWN_COOKIE_NAME, TWENTY_YEARS_IN_SEC;

TWENTY_YEARS_IN_SEC = 630720000;

TUTORIAL_SHOWN_COOKIE_NAME = 'clo-cash-back-tutorial-shown';

if (window.CashBack == null) {
  window.CashBack = {};
}

CashBack.init = function(payload, done) {
  return $(function() {
    var $tooltipCloser, $window, cashBack, cookieDomain, tooltipDelay, tutorialLauncher;
    cashBack = payload.cashBack, cookieDomain = payload.cookieDomain;
    if (cashBack != null ? cashBack.showTutorialOnLoad : void 0) {
      tooltipDelay = $('#ls-in-app-messages:not(.hide)').length ? (cashBack != null ? cashBack.tooltipDelay : void 0) || 2000 : 0;
      tutorialLauncher = function() {
        return CashBack.showTutorial(cookieDomain);
      };
      setTimeout(tutorialLauncher, tooltipDelay);
    }
    $tooltipCloser = $('.tooltip-close.icon-x');
    if ($tooltipCloser.length > 0) {
      $tooltipCloser.off('click');
      $tooltipCloser.on('click', GIG.Tooltip.helpers.hideTooltip);
    }
    $window = $(window);
    $window.scroll(function() {
      var height, ratio, scrollTop;
      scrollTop = $window.scrollTop();
      height = $window.height();
      ratio = (height - scrollTop) / height;
      $('#cash-back-tutorial-tooltip').css({
        'opacity': ratio
      });
      if (ratio < 0.3) {
        return $tooltipCloser.click();
      }
    });
    return done();
  });
};

CashBack.showTutorial = function(cookieDomain) {
  var $tooltip, $trigger, onTooltipClose;
  if (Cookie.get(TUTORIAL_SHOWN_COOKIE_NAME)) {
    return;
  }
  if (cookieDomain == null) {
    cookieDomain = window.location.hostname;
  }
  $tooltip = $('#cash-back-tutorial-tooltip');
  if (!$tooltip.length) {
    return;
  }
  onTooltipClose = function() {
    return Cookie.set(TUTORIAL_SHOWN_COOKIE_NAME, 'true', TWENTY_YEARS_IN_SEC, cookieDomain);
  };
  $tooltip.one('click', '.tooltip-close', onTooltipClose);
  $trigger = $('.cash-back .tooltip-trigger');
  return GIG.Tooltip.helpers.tooltip.apply($trigger, [
    {
      preventDefault: function() {}
    }
  ]);
};

module.exports = CashBack;


/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

var JuiceProgram;

JuiceProgram = window.JuiceProgram != null ? window.JuiceProgram : window.JuiceProgram = {};

JuiceProgram.Model = __webpack_require__(428);

JuiceProgram.View = __webpack_require__(431);

JuiceProgram.init = function(arg, done) {
  var buyButton, juiceModel, juiceView, ref;
  buyButton = arg.buyButton;
  if (done == null) {
    done = function() {};
  }
  if (!((ref = buyButton.JuiceProgramInfo) != null ? ref.isJuiceProgramEnabled : void 0)) {
    return;
  }
  juiceModel = new JuiceProgram.Model(buyButton.JuiceProgramInfo);
  juiceView = new JuiceProgram.View({
    model: juiceModel
  });
  return $((function(_this) {
    return function() {
      juiceView.render();
      return done();
    };
  })(this));
};

module.exports = JuiceProgram;


/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var JuiceProgramModel, clockTimeLeft, progressComplete, ref, textTimeLeft;

ref = __webpack_require__(429), clockTimeLeft = ref.clockTimeLeft, textTimeLeft = ref.textTimeLeft, progressComplete = ref.progressComplete;

module.exports = JuiceProgramModel = Backbone.Model.extend({
  constructor: function(juiceInfo) {
    var juiceProgramEndTime, juiceProgramStartTime;
    if (juiceInfo == null) {
      juiceInfo = {};
    }
    juiceProgramStartTime = juiceInfo.juiceProgramStartTime, juiceProgramEndTime = juiceInfo.juiceProgramEndTime;
    if (juiceProgramStartTime != null) {
      this.startAt = new Date(juiceProgramStartTime);
    }
    if (juiceProgramEndTime != null) {
      this.endAt = new Date(juiceProgramEndTime);
    }
    return Backbone.Model.apply(this, arguments);
  },
  timeLeft: function() {
    var clockTime, progress, textTime;
    if ((clockTime = clockTimeLeft(this.endAt)) && (textTime = textTimeLeft(this.endAt)) && (this.startAt != null)) {
      progress = progressComplete(this.startAt, this.endAt);
      return {
        clockTime: clockTime,
        progress: progress,
        textTime: textTime
      };
    }
  }
});


/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESKTOP_FF_NAME, JUICE_PROGRAM_ID, TIMER_ADJUST_MINUTES, clockTimeLeft, formatJuiceTimer, formatTextTimer, isInJuiceGracePeriod, isJuicePricingOption, isJuiceProgramEnabled, millisRemaining, progressComplete, ref, ref1, setAdjustedJuiceTime, textTimeLeft, timeRemaining;

ref = __webpack_require__(285), millisRemaining = ref.millisRemaining, timeRemaining = ref.timeRemaining;

ref1 = __webpack_require__(430), JUICE_PROGRAM_ID = ref1.JUICE_PROGRAM_ID, DESKTOP_FF_NAME = ref1.DESKTOP_FF_NAME, TIMER_ADJUST_MINUTES = ref1.TIMER_ADJUST_MINUTES;

setAdjustedJuiceTime = function(deal, attributes, featureFlags) {
  var endAt, endAtDate, ref2, ref3, ref4, ref5;
  if (!isJuiceProgramEnabled({
    attributes: attributes,
    featureFlags: featureFlags
  })) {
    return;
  }
  if (isJuicePricingOption(deal != null ? deal.displayOption : void 0)) {
    endAt = (ref2 = deal.displayOption) != null ? (ref3 = ref2.pricingMetadata) != null ? ref3.offerEndsAt : void 0 : void 0;
    endAtDate = new Date(endAt);
    if ((ref4 = deal.displayOption) != null) {
      if ((ref5 = ref4.pricingMetadata) != null) {
        ref5.offerEndsAt = new Date(endAtDate - TIMER_ADJUST_MINUTES * 60 * 1000).toISOString();
      }
    }
  }
  if (isInJuiceGracePeriod(deal != null ? deal.displayOption : void 0)) {
    deal.displayOption.price = deal.displayOption.regularPrice;
    return deal.displayOption.discountPercent = Math.round((deal.displayOption.value.amount - deal.displayOption.regularPrice.amount) / deal.displayOption.value.amount * 100);
  }
};

isInJuiceGracePeriod = function(dealOption) {
  var endDate, now, offerBeginsAt, offerEndsAt, ref2, ref3;
  if ((dealOption != null ? (ref2 = dealOption.pricingMetadata) != null ? ref2.programId : void 0 : void 0) !== JUICE_PROGRAM_ID) {
    return;
  }
  ref3 = dealOption.pricingMetadata, offerBeginsAt = ref3.offerBeginsAt, offerEndsAt = ref3.offerEndsAt;
  if (!(offerBeginsAt && offerEndsAt)) {
    return;
  }
  now = new Date();
  if (offerEndsAt != null) {
    endDate = new Date(offerEndsAt);
  }
  return endDate <= now;
};

isJuicePricingOption = function(dealOption) {
  var endDate, now, offerBeginsAt, offerEndsAt, ref2, ref3, startDate;
  if ((dealOption != null ? (ref2 = dealOption.pricingMetadata) != null ? ref2.programId : void 0 : void 0) !== JUICE_PROGRAM_ID) {
    return;
  }
  ref3 = dealOption.pricingMetadata, offerBeginsAt = ref3.offerBeginsAt, offerEndsAt = ref3.offerEndsAt;
  if (!(offerBeginsAt && offerEndsAt)) {
    return;
  }
  now = new Date();
  if (offerBeginsAt != null) {
    startDate = new Date(offerBeginsAt);
  }
  if (offerEndsAt != null) {
    endDate = new Date(offerEndsAt);
  }
  return (startDate <= now && now <= endDate);
};

isJuiceProgramEnabled = function(arg) {
  var attributes, featureFlags, touchRequest;
  attributes = arg.attributes, featureFlags = arg.featureFlags;
  if (!(attributes && featureFlags)) {
    return;
  }
  touchRequest = attributes.touchRequest;
  return !touchRequest && featureFlags.enabled(DESKTOP_FF_NAME);
};

progressComplete = function(startDate, endDate) {
  var fullTime, msLeft;
  if (!(startDate && endDate)) {
    return;
  }
  fullTime = endDate - startDate;
  if (!(fullTime > 0)) {
    return;
  }
  msLeft = millisRemaining(endDate);
  return Number(((fullTime - msLeft) / fullTime).toFixed(2));
};

clockTimeLeft = function(endDate) {
  var msLeft, remainedTime;
  if (!endDate) {
    return;
  }
  msLeft = millisRemaining(endDate);
  if (!(msLeft > 0)) {
    return;
  }
  if (remainedTime = timeRemaining(msLeft)) {
    return formatJuiceTimer(remainedTime);
  }
};

textTimeLeft = function(endDate) {
  var msLeft, remainedTime;
  if (!endDate) {
    return;
  }
  msLeft = millisRemaining(endDate);
  if (!(msLeft > 0)) {
    return;
  }
  if (remainedTime = timeRemaining(msLeft)) {
    return formatTextTimer(remainedTime);
  }
};

formatJuiceTimer = function(remainedTime) {
  var minutes, seconds;
  minutes = remainedTime.minutes, seconds = remainedTime.seconds;
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return minutes + ":" + seconds;
};

formatTextTimer = function(remainedTime) {
  var minutes, seconds;
  minutes = remainedTime.minutes, seconds = remainedTime.seconds;
  return minutes + "m " + seconds + "s";
};

module.exports = {
  textTimeLeft: textTimeLeft,
  clockTimeLeft: clockTimeLeft,
  formatJuiceTimer: formatJuiceTimer,
  formatTextTimer: formatTextTimer,
  isInJuiceGracePeriod: isInJuiceGracePeriod,
  isJuicePricingOption: isJuicePricingOption,
  isJuiceProgramEnabled: isJuiceProgramEnabled,
  progressComplete: progressComplete,
  setAdjustedJuiceTime: setAdjustedJuiceTime
};


/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESKTOP_FF_NAME, JUICE_CLIENT_PROPERTIES, JUICE_PROGRAM_ID, TIMER_ADJUST_MINUTES, TOUCH_FF_NAME;

JUICE_PROGRAM_ID = '08e634b4-bf92-4b34-8ec4-a5688591db64';

DESKTOP_FF_NAME = 'show_juice_program_desktop';

TOUCH_FF_NAME = 'show_juice_program_touch';

JUICE_CLIENT_PROPERTIES = ['isJuiceProgramEnabled', 'juiceProgramEndTime', 'juiceProgramStartTime'];

TIMER_ADJUST_MINUTES = 5;

module.exports = {
  JUICE_PROGRAM_ID: JUICE_PROGRAM_ID,
  DESKTOP_FF_NAME: DESKTOP_FF_NAME,
  TOUCH_FF_NAME: TOUCH_FF_NAME,
  JUICE_CLIENT_PROPERTIES: JUICE_CLIENT_PROPERTIES,
  TIMER_ADJUST_MINUTES: TIMER_ADJUST_MINUTES
};


/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

var CircularProgressBar, JuiceProgramView, attributeNames, classNames, obj, once, ref, selectors;

once = __webpack_require__(1).once;

ref = __webpack_require__(432), attributeNames = ref.attributeNames, classNames = ref.classNames, selectors = ref.selectors;

CircularProgressBar = __webpack_require__(433);

module.exports = JuiceProgramView = Backbone.View.extend({
  UPDATE_COUNTDOWN_MS: 1000,
  CLEAN_VIEW_ANIMATION_MS: 2000,
  el: selectors.purchaseCluster + ", " + selectors.multiOptionOverlay,
  events: (
    obj = {},
    obj["click " + selectors.inlineOptionInput] = 'optionSelected',
    obj["click " + selectors.multiOptionOverlayInput] = 'optionSelected',
    obj["click " + selectors.viewMoreButton] = 'viewMoreButtonClicked',
    obj
  ),
  initialize: function() {
    this.juiceProgramEnded = !this.model.timeLeft();
    this.$el.addClass(classNames.juiceProgramEnabled);
    this.overlayExists = this.$(selectors.multiOptionOverlayInput).length > 0;
    return this.progressBar = new CircularProgressBar({
      el: selectors.bannerMessage
    });
  },
  render: function() {
    if (this._juiceTimer != null) {
      clearInterval(this._juiceTimer);
    }
    this._juiceTimer = setInterval(((function(_this) {
      return function() {
        return _this.updateJuiceCountdown();
      };
    })(this)), this.UPDATE_COUNTDOWN_MS);
    return this;
  },
  optionSelected: function(e) {
    return this.updateJuicePrices(this.$(e.currentTarget));
  },
  viewMoreButtonClicked: once(function() {
    return this.updateJuicePrices(this.$(selectors.multiOptionOverlayInput).filter(':checked'));
  }),
  updateJuicePrices: function($option) {
    var ref1;
    if (this.juiceProgramEnded || !$option) {
      return;
    }
    return (ref1 = this.$(selectors.extraDiscount)) != null ? ref1.text($option.attr(attributeNames.extraDiscount)) : void 0;
  },
  updateJuiceCountdown: function() {
    var countDownTimer, ref1, ref2, ref3, timeLeft;
    if (timeLeft = this.model.timeLeft()) {
      if ((ref1 = this.$(selectors.timerInBannerMessage)) != null) {
        ref1.text(timeLeft.textTime);
      }
      this.progressBar.updateProgress(timeLeft.progress, timeLeft.clockTime);
      this.$('.countdown-timer').text(timeLeft.clockTime);
      if (countDownTimer = typeof CountdownTimer !== "undefined" && CountdownTimer !== null ? (ref2 = CountdownTimer.current) != null ? (ref3 = ref2.timerView) != null ? ref3.interval : void 0 : void 0 : void 0) {
        return clearInterval(countDownTimer);
      }
    } else {
      this.juiceProgramEnded = true;
      clearInterval(this._juiceTimer);
      this.cleanJuiceUI();
      return this.undelegateEvents();
    }
  },
  cleanJuiceUI: function() {
    this.removeJuiceElements();
    this.changeToOldPrices();
    this.$el.addClass(classNames.juiceProgramExpired);
    this.$el.removeClass(classNames.juiceProgramEnabled);
    return this.$(selectors.bannerMessage).animate({
      'height': '0px',
      'opacity': 0,
      'padding-top': '0px',
      'padding-bottom': '0px'
    }, this.CLEAN_VIEW_ANIMATION_MS, 'linear', (function(_this) {
      return function() {
        return _this.$(selectors.bannerMessage).remove();
      };
    })(this));
  },
  removeJuiceElements: function() {
    var juiceElements;
    juiceElements = [selectors.offerLabel, selectors.discountBadge, selectors.overlayClusterDiscount];
    return this.$(juiceElements.join(', ')).remove();
  },
  changeToOldPrices: function() {
    var $input, attrsToRemove, element, i, len, price, priceLabel, ref1, ref2, ref3, regularPrice;
    this.$('.breakout-option-price').addClass('c-txt-price').removeClass('urgency-pricing c-txt-err');
    attrsToRemove = [attributeNames.regularPrice, attributeNames.extraDiscount, attributeNames.discountPercentage, attributeNames.offerLabel].join(' ');
    ref1 = this.$(selectors.inlineOptionInput + ", " + selectors.multiOptionOverlayInput);
    for (i = 0, len = ref1.length; i < len; i++) {
      element = ref1[i];
      $input = this.$(element);
      regularPrice = $input.attr(attributeNames.regularPrice);
      $input.removeAttr(attrsToRemove).attr(attributeNames.price, regularPrice);
      priceLabel = (ref2 = $input.next('label')) != null ? ref2.find('.breakout-option-price') : void 0;
      priceLabel.text(regularPrice);
    }
    if (this.overlayExists) {
      price = (ref3 = this.$(selectors.multiOptionOverlayInput).filter(':checked')) != null ? ref3.attr(attributeNames.price) : void 0;
      return this.$(selectors.overlayClusterPrice).text(price).addClass('c-txt-price').removeClass('tooltip-trigger urgency-pricing');
    }
  }
});


/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var attributeNames, classNames, selectors;

attributeNames = {
  extraDiscount: 'data-formatted-extra-discount',
  discountPercentage: 'data-discount-percentage',
  offerLabel: 'data-offer-label',
  price: 'data-formatted-price',
  regularPrice: 'data-formatted-regular-price',
  value: 'data-formatted-value'
};

classNames = {
  bannerMessage: 'juice-banner-message',
  juiceProgramEnabled: 'juice-program-enabled',
  juiceProgramExpired: 'juice-program-expired'
};

selectors = {
  bannerMessage: "." + classNames.bannerMessage,
  discountBadge: '.breakout-pricing-messages .discount-message-wrapper',
  extraDiscount: "." + classNames.bannerMessage + " .extra-discount",
  inlineOptionInput: '.multi-option-breakout input',
  multiOptionOverlay: '.multi-option-overlay',
  multiOptionOverlayInput: '.multi-option-overlay-item input',
  offerLabel: '.breakout-pricing-messages .urgency-pricing-label',
  overlayClusterDiscount: '.multi-option-overlay-cluster-row .discount-message',
  overlayClusterPrice: '.multi-option-overlay-cluster-price',
  purchaseCluster: '#purchase-cluster',
  timerInBannerMessage: "." + classNames.bannerMessage + " .time-left",
  viewMoreButton: '.view-options a'
};

module.exports = {
  attributeNames: attributeNames,
  classNames: classNames,
  selectors: selectors
};


/***/ }),

/***/ 433:
/***/ (function(module, exports) {

var CircleProgressBarView;

module.exports = CircleProgressBarView = Backbone.View.extend({
  className: 'circular-progress-bar',
  initialize: function() {
    this.$status = this.$('.status');
    this.$rightSlice = this.$('.right-half .slice');
    this.$leftSlice = this.$('.left-half .slice');
    return this.$leftHalf = this.$('.left-half');
  },
  updateProgress: function(progress, text) {
    var drawAngle, firstHalfAngle, secondHalfAngle;
    if (!((0 <= progress && progress <= 1))) {
      return;
    }
    firstHalfAngle = 180;
    secondHalfAngle = 0;
    drawAngle = progress * 360;
    if (drawAngle <= 180) {
      firstHalfAngle = drawAngle;
    } else {
      this.removeClips(this.$leftHalf);
      this.removeClips(this.$rightSlice);
      secondHalfAngle = drawAngle - 180;
    }
    this.rotate(this.$rightSlice, firstHalfAngle);
    this.rotate(this.$leftSlice, secondHalfAngle);
    return this.$status.text(text);
  },
  rotate: function(element, degree) {
    return element != null ? element.css({
      'transform': "rotate(" + degree + "deg)"
    }) : void 0;
  },
  removeClips: function(element) {
    if (element.css('clip') !== 'auto') {
      return element.css('clip', 'auto');
    }
  }
});


/***/ }),

/***/ 434:
/***/ (function(module, exports) {

if (window.DesktopMenu == null) {
  window.DesktopMenu = {};
}

DesktopMenu.removeMenuHtml = function() {
  $('.menu-button').remove();
  return $('#menu-modal').remove();
};

DesktopMenu.displayMenuHtml = function(modalHtml) {
  if (modalHtml == null) {
    DesktopMenu.removeMenuHtml();
  }
  $('.menu-button').css('display', 'inline-block');
  $('section.deal').after(modalHtml);
  return GIG.Modal.reloadBindings($('#menu-modal'));
};

DesktopMenu.ajax_request = function(menuData) {
  return $.ajax({
    url: menuData.formattedUrl,
    dataType: 'html',
    success: DesktopMenu.displayMenuHtml,
    error: DesktopMenu.removeMenuHtml
  });
};

DesktopMenu.init = function(arg, done) {
  var menuData;
  menuData = arg.menuData;
  if (menuData == null) {
    DesktopMenu.removeMenuHtml();
    return done();
  }
  DesktopMenu.ajax_request(menuData);
  return done();
};

module.exports = DesktopMenu;


/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global BOOMR, window, $ */
/*eslint-disable no-undef*/



// code spliting

__webpack_require__(50);

__webpack_require__.p = assetsUrl;

$(window).load(function () {
  var modulePromises = [];
  if (window.payload.loadSwitch && window.payload.loadSwitch.shouldLoadDealWidgets) {
    modulePromises.push(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 240)));
  }
  if (window.payload.loadSwitch && window.payload.loadSwitch.shouldShowTipWidget) {
    modulePromises.push(__webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 516)));
  }
  if (window.payload.merchantV2) {
    modulePromises.push(__webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 517)));
  } else {
    modulePromises.push(__webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 518)));
  }

  window.asyncInitializer(modulePromises, 40 * 1000, function (initStart) {
    if (typeof BOOMR !== 'undefined' && typeof BOOMR.addVar === 'function') {
      BOOMR.addVar('deal_page_async_modules_loaded', new Date() - initStart);
    }
  });
});

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

var lazyLoadMerchantLocations;

lazyLoadMerchantLocations = window.lazyLoadMerchantLocations != null ? window.lazyLoadMerchantLocations : window.lazyLoadMerchantLocations = {};

if (window.GMap == null) {
  window.GMap = {};
}

lazyLoadMerchantLocations.reload = function(data) {
  var el, merchantHtml, merchantModalHtml, ref, touchRequest, unbindFirst;
  merchantHtml = data.merchantHtml, merchantModalHtml = data.merchantModalHtml, touchRequest = data.touchRequest;
  if (merchantHtml.length) {
    if (GMap.isLoaded) {
      GMap.init(data, function() {});
    } else {
      GMap.asyncMapData = data;
    }
  }
  if (!touchRequest && merchantModalHtml.length) {
    return typeof GIG !== "undefined" && GIG !== null ? (ref = GIG.Modal) != null ? ref.reloadBindings(el = document.body, unbindFirst = false) : void 0 : void 0;
  }
};

lazyLoadMerchantLocations.ajax_success = function(data) {
  var $lastTooltip, $tooltipAndModalData, dealTitleMerchantInfoHtml, merchantHtml, merchantModalHtml, touchRequest;
  if (!data) {
    return;
  }
  dealTitleMerchantInfoHtml = data.dealTitleMerchantInfoHtml, merchantHtml = data.merchantHtml, merchantModalHtml = data.merchantModalHtml, touchRequest = data.touchRequest;
  if (merchantHtml.length) {
    $('#merchant-locations-placeholder').replaceWith(merchantHtml);
  } else {
    $('#merchant-locations-placeholder').remove();
  }
  if (dealTitleMerchantInfoHtml.length) {
    $('#deal-subtitle-container').replaceWith(dealTitleMerchantInfoHtml);
  }
  if (touchRequest) {
    if (merchantModalHtml.length) {
      $('.t-main').after(merchantModalHtml);
    }
  } else {
    $tooltipAndModalData = "";
    if (_.isString(merchantModalHtml)) {
      $tooltipAndModalData += merchantModalHtml;
    }
    if ($tooltipAndModalData.length) {
      $lastTooltip = $('.tooltip').last() || $('section.main');
      $lastTooltip.after($tooltipAndModalData);
    }
  }
  return lazyLoadMerchantLocations.reload(data);
};

lazyLoadMerchantLocations.init = function(payload, done) {
  var clientSideMerchantLocations;
  clientSideMerchantLocations = payload.clientSideMerchantLocations;
  if (clientSideMerchantLocations == null) {
    return done();
  }
  return $(function() {
    return $(window).load(function() {
      $.ajax({
        url: clientSideMerchantLocations.formattedUrl,
        dataType: 'json',
        success: lazyLoadMerchantLocations.ajax_success,
        error: function(err) {
          $('#merchant-location-placeholder').remove();
          return done();
        }
      });
      return done();
    });
  });
};

module.exports = lazyLoadMerchantLocations;


/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window, $ */



// eslint-disable-next-line no-undef

__webpack_require__.p = assetsUrl;

$(window).load(function () {
  if (window.payload === undefined || window.payload.sharing === undefined) {
    return;
  }
  var fb_promise = __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 239));
  fb_promise.then(function (facebook_script) {
    facebook_script.fbPostponedScriptLoading();
  }).catch(function (err) {
    if (false) {
      // eslint-disable-next-line no-console
      console.log('Failed to load facebook_script', err);
    }
  });
});

/***/ })

},[421]);


// WEBPACK FOOTER //
// local-c31da8e197.js